<template>
  <div>
    <!-- <div>
      <el-button-group>
        <el-button type="primary" icon="el-icon-check" @click="selectall()"
          >全选</el-button
        >
        <el-button type="primary" icon="el-icon-close" @click="reset()"
          >重置</el-button
        >
      </el-button-group>
    </div> -->
    <div>
      <el-tree
        ref="tree"
        show-checkbox
        node-key="id"
        :data="treedata"
        :props="defaultProps"
        @node-click="handleNodeClick"
        @check-change="handleCheckChange"
        :default-expanded-keys="['00']"
      ></el-tree>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import Qs from "qs";
import global from "../global.vue";
import AES from "../AES.js";

export default {
  data() {
    return {
      checkStrictly: true,
      mlkeys: [],
      treedata: [
        {
          id: "0",
          label: "全部 -- 0",
          children: [
            {
              id: "01",
              label: "电脑图书 -- 01",
              children: [
                {
                  id: "0101",
                  label: "计算机图书 -- 0101",
                  children: [
                    { id: "TP01", label: "操作系统 -- TP01" },
                    { id: "TP11", label: "网络通讯 -- TP11" },
                    { id: "TP12", label: "网络安全 -- TP12" },
                    { id: "TP13", label: "网页设计 -- TP13" },
                    { id: "TP14", label: "电子商务 -- TP14" },
                    { id: "TP21", label: "数 据 库 -- TP21" },
                    { id: "TP31", label: "编程语言 -- TP31" },
                    { id: "TP41", label: "辅助设计 -- TP41" },
                    { id: "TP42", label: "平面设计 -- TP42" },
                    { id: "TP43", label: "三维设计 -- TP43" },
                    { id: "TP52", label: "系统原理及维护 -- TP52" },
                  ],
                },
                {
                  id: "0102",
                  label: "计算机综合 -- 0102",
                  children: [{ id: "010201", label: "三级 01-02-01" }],
                },
                {
                  id: "0103",
                  label: "计算机工具书 -- 0103",
                  children: [{ id: "010301", label: "三级 01-03-01" }],
                },
              ],
            },
            {
              id: "02",
              label: "文教图书 -- 02",
              children: [
                {
                  id: "21",
                  label: "二级 2-1",
                  children: [{ id: "211", label: "三级 2-1-1" }],
                },
                {
                  id: "22",
                  label: "二级 2-2",
                  children: [{ id: "221", label: "三级 2-2-1" }],
                },
              ],
            },
            {
              id: "03",
              label: "科技图书 -- 03",
              children: [
                {
                  id: "31",
                  label: "二级 3-1",
                  children: [{ id: "311", label: "三级 3-1-1" }],
                },
                {
                  id: "32",
                  label: "二级 3-2",
                  children: [{ id: "321", label: "三级 3-2-1" }],
                },
              ],
            },
            {
              id: "04",
              label: "社科图书 -- 04",
              children: [
                {
                  id: "41",
                  label: "二级 4-1",
                  children: [{ id: "411", label: "三级 4-1-1" }],
                },
                {
                  id: "42",
                  label: "二级 4-2",
                  children: [{ id: "421", label: "三级 4-2-1" }],
                },
              ],
            },
          ],
        },
      ],
      alldata: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
    };
  },

  components: {},

  created() {
    this.gettreedata();
  },

  methods: {
    selectall() {
      /*
window.localStorage.removeItem("mlkeys");
      var mlkeys = window.localStorage.getItem("mlkeys");
      console.log();
      console.log(mlkeys);
      if (mlkeys == null) {
        console.log("开始获取目录keys");

        var stoken = window.localStorage.getItem("stoken");
        axios({
          headers: {
            "Content-type": "text/xml",
            token: stoken,
          },
          method: "post",
          url: global.sserverip + "getskucategorykeys",
          data: "1",
        })
          .then(function (res) {
            //TO-DO 先判断下数据是否正确 status
            //console.log(oresult);
            console.log("获取目录keys完成");
            console.log("res"+res);
            // mlkeys = JSON.parse(res);
            mlkeys = res;
            window.localStorage.setItem("mlkeys", mlkeys);
          })
          .catch(function (err) {
            console.log(err);
          });
      } else {
        console.log("本地已有目录keys");
      }
            console.log("mlkeys"+mlkeys);
*/

      console.log("开始获取目录keys");

      let that = this;
      var stoken = window.localStorage.getItem("stoken");
      axios({
        headers: {
          "Content-type": "text/xml",
          token: stoken,
        },
        method: "post",
        url: global.sserverip + "getskucategorykeys",
        data: "1",
      })
        .then(function (res) {
          //TO-DO 先判断下数据是否正确 status
          // console.log(res.data);
          // console.log("获取目录keys完成");
          that.$refs.tree.setCheckedKeys(res.data, true);
        })
        .catch(function (err) {
          console.log(err);
        });
    },

    reset() {
      this.$refs.tree.setCheckedNodes([]);
    },
    handleCheckChange(treedata, checked, indeterminate) {
      //       console.log(treedata, checked, indeterminate);
      var pdata = this.$refs.tree.getCheckedKeys();
      console.log("pdata:");
      console.log(pdata);
      this.$emit("pushdata", pdata);
    },
    gettreedata() {
      let that = this;
      var stoken = window.localStorage.getItem("stoken");
      stoken = AES.decrypt(stoken, global.AEScode);
      var stokenencrypts = AES.encrypt(stoken, global.AEScode);
      var stoken = window.localStorage.getItem("stoken");
      // axios.defaults.headers.common["token"] = stoken;
      axios({
        headers: {
          "Content-type": "text/xml",
          token: stoken,
        },
        method: "post",
        url: global.sserverip + "getskucategory",
        data: stokenencrypts,
      })
        .then(function (res) {
          //TO-DO 先判断下数据是否正确 status
          var oresult = AES.decrypt(res.data, global.AEScode);
            //console.log(oresult);
          if (oresult === "no token!") {
          } else {
            that.treedata = JSON.parse(oresult);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },

    handleNodeClick(treedata) {
      //console.log(treedata);
    },
  },
};
</script>


<style>
</style>
